var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/**
 * Copyright 2022, SumUp Ltd.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { css, ClassNames, Global } from '@emotion/react';
import ReactModal from 'react-modal';
import { StackContext } from '../../../StackContext';
import { SIDE_PANEL_WIDTH, PORTAL_CLASS_NAME, TRANSITION_DURATION_DESKTOP, } from '../../SidePanel';
export const DesktopSidePanel = (_a) => {
    var { children, isInstantOpen, top } = _a, props = __rest(_a, ["children", "isInstantOpen", "top"]);
    return (_jsx(ClassNames, { children: ({ css: cssString, cx, theme }) => {
            // React Modal styles
            // https://reactcommunity.org/react-modal/styles/classes/
            const styles = {
                base: cssString `
          height: 100%;
          outline: none;
          background-color: var(--cui-bg-normal);
          box-shadow: inset ${theme.borderWidth.kilo} 0px 0px var(--cui-border-divider);
          transform: translateX(100%);
          transition: transform ${TRANSITION_DURATION_DESKTOP}ms ease-in-out;
        `,
                afterOpen: cx(cssString `
            transform: translateX(0);
          `, isInstantOpen &&
                    cssString `
              transition: none;
            `),
                beforeClose: cssString `
          transform: translateX(100%) !important;
          transition: transform ${TRANSITION_DURATION_DESKTOP}ms ease-in-out !important;
        `,
            };
            const overlayStyles = cssString `
        height: 100%;
      `;
            const reactModalProps = Object.assign({ ariaHideApp: false, className: styles, overlayClassName: overlayStyles, shouldCloseOnOverlayClick: false, closeTimeoutMS: TRANSITION_DURATION_DESKTOP }, props);
            return (_jsxs(StackContext.Provider, Object.assign({ value: theme.zIndex.absolute }, { children: [_jsx(ReactModal, Object.assign({}, reactModalProps, { children: children })), _jsx(Global, { styles: css `
              /* Enable keyboard navigation inside the modal, see https://github.com/reactjs/react-modal/issues/782 */
              .${PORTAL_CLASS_NAME} {
                position: fixed;
                top: ${top};
                right: 0;
                bottom: 0;
                width: ${SIDE_PANEL_WIDTH};
                z-index: ${theme.zIndex.absolute};
              }
            ` })] })));
        } }));
};
